import './vendors/slick.js';

export function carousels() {

    /**
     * Image Cards Carousel on mobile
     */
    (function() {
        const $slider = $('.image-cards-slider');

        if (!$slider.length) return;

        const mq = window.matchMedia('(max-width: 839px)');

        $slider.each(function() {
            const $this = $(this);
            const $prev = $this.next().find('.prev-slide');
            const $next = $this.next().find('.next-slide');

            function updateNavState(slick) {
                const atStart = slick.currentSlide === 0;
                const atEnd = slick.currentSlide >= slick.slideCount - slick.options.slidesToShow;
                $prev.prop('disabled', atStart);
                $next.prop('disabled', atEnd);
            }

            $this.on('init afterChange', function (event, slick) {
                updateNavState(slick);
            });

            $prev.on('click', function () {
                $this.slick('slickPrev');
            });

            $next.on('click', function () {
                $this.slick('slickNext');
            });
        });

        function syncSlider(e) {
            $slider.each(function() {
                const $this = $(this);
                const initialized = $this.hasClass('slick-initialized');

                if (e.matches && !initialized) {
                    $this.slick({
                        dots: false,
                        speed: 500,
                        arrows: false,
                        infinite: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: '40px'
                    });
                } else if (!e.matches && initialized) {
                    $this.slick('unslick');
                }
            });
        }

        syncSlider(mq);
        mq.addEventListener('change', syncSlider);

    })();

    /**
     * Media Carousel
     */
    (function() {
        const $slider = $('.media-carousel-slider');

        //Hide the nav (arrows and dots) when there's only a single slide.
        $slider.on('init', function (event, slick) {
            if (slick.slideCount <= 1) {
                $(this).siblings('.custom-carousel-nav').hide();
            }
        });

        // Video facades. Iframes ship with `data-src` (see block-media-carousel.html)
        // so no third-party player (YouTube, Vimeo, Facebook) is downloaded at page
        // load or when sliding. A player loads ONLY when its poster is activated
        // (click, Enter or Space), with autoplay; leaving the slide unloads it again.
        // A slide without an authored poster image gets a generic facade (scrim +
        // play icon) so it is click-to-load too. Legacy markup with a plain `src`
        // is migrated to `data-src` here (the browser has already started that
        // load, so such slides only gain the unload-on-leave behaviour).
        $slider.find('iframe').each(function () {
            const $iframe = $(this);
            if (!$iframe.attr('data-src') && $iframe.attr('src')) {
                $iframe.attr('data-src', $iframe.attr('src'));
            }
            $iframe.removeAttr('src');
        });

        // Runs once before slick initialises, so slick's clones copy the facades.
        function ensurePosters() {
            $slider.find('.embed-container').each(function () {
                const $container = $(this);
                const $iframe = $container.find('iframe[data-src]').first();
                if (!$iframe.length) return;
                let $poster = $container.children('.video-poster').first();
                if (!$poster.length) {
                    $poster = $('<div class="video-poster video-poster--generic"></div>').insertBefore($iframe);
                }
                const title = ($iframe.attr('title') || '').trim();
                if (!$poster.attr('role')) $poster.attr('role', 'button');
                if (!$poster.attr('tabindex')) $poster.attr('tabindex', '0');
                if (!$poster.attr('aria-label')) $poster.attr('aria-label', title ? 'Play video: ' + title : 'Play video');
            });
        }
        ensurePosters();

        // Permissions the loaded player needs (same list as video-lightbox.js);
        // merged with whatever the markup already allows.
        const PLAYER_ALLOW = ['autoplay', 'fullscreen', 'picture-in-picture', 'encrypted-media'];

        // Facebook videos: the plugins/video.php iframe ignores its autoplay
        // parameter when it is created after a click, so the visitor would have
        // to press play a second time inside Facebook's player. The Facebook JS
        // SDK player does start on our click (muted; Facebook only allows sound
        // after a gesture inside its own frame), so Facebook slides are rendered
        // with it instead. The SDK is fetched on the first Facebook play only.
        const FB_PLUGIN = 'facebook.com/plugins/video.php';
        const FB_SDK_URL = 'https://connect.facebook.net/en_US/sdk.js';
        let fbSdkReady = null;
        const fbPending = {};   // fb-video element id -> callback once its player instance exists
        const fbPlayers = {};   // fb-video element id -> player instance
        let fbCount = 0;

        function facebookVideoUrl(pluginSrc) {
            try {
                return new URL(pluginSrc).searchParams.get('href');
            } catch (e) {
                return null;
            }
        }

        function loadFacebookSdk() {
            if (fbSdkReady) return fbSdkReady;
            fbSdkReady = new Promise(function (resolve) {
                if (!document.getElementById('fb-root')) {
                    $('<div id="fb-root"></div>').prependTo(document.body);
                }
                const previousInit = window.fbAsyncInit;
                window.fbAsyncInit = function () {
                    if (typeof previousInit === 'function') previousInit();
                    FB.init({ xfbml: false, version: 'v19.0' });
                    FB.Event.subscribe('xfbml.ready', function (msg) {
                        if (msg.type !== 'video') return;
                        fbPlayers[msg.id] = msg.instance;
                        if (fbPending[msg.id]) {
                            fbPending[msg.id](msg.instance);
                            delete fbPending[msg.id];
                        }
                    });
                    resolve();
                };
                const script = document.createElement('script');
                script.async = true;
                script.src = FB_SDK_URL;
                document.body.appendChild(script);
            });
            return fbSdkReady;
        }

        function loadFacebookVideo($iframe, autoplay) {
            const href = facebookVideoUrl($iframe.attr('data-src'));
            if (!href) return;
            const $container = $iframe.closest('.embed-container');
            const id = 'fb-video-' + (++fbCount);
            const $video = $('<div class="fb-video"></div>').attr({
                id: id,
                'data-href': href,
                'data-width': Math.round($container.width()) || 560,
                'data-allowfullscreen': 'true',
                'data-autoplay': autoplay ? 'true' : 'false',
                'data-show-text': 'false'
            }).insertBefore($iframe);
            // The src-less placeholder iframe is absolutely positioned on top of the
            // box; hide it or it covers the SDK player and swallows every click
            // (no hover controls, no unmute). unloadVideos() shows it again.
            $iframe.css('display', 'none');
            if (autoplay) {
                fbPending[id] = function (player) { player.play(); };
            }
            loadFacebookSdk().then(function () {
                if ($video.closest('body').length) FB.XFBML.parse($container[0]);
            });
        }

        function loadVideo($iframe, autoplay) {
            const src = $iframe.attr('data-src');
            if (!src) return;
            if (src.includes(FB_PLUGIN)) {
                loadFacebookVideo($iframe, autoplay);
                return;
            }
            const allowed = ($iframe.attr('allow') || '').split(';').map(s => s.trim()).filter(Boolean);
            PLAYER_ALLOW.forEach(p => { if (!allowed.includes(p)) allowed.push(p); });
            $iframe.attr('allow', allowed.join('; '));
            if (!autoplay) {
                $iframe.attr('src', src);
                return;
            }
            const sep = src.includes('?') ? '&' : '?';
            $iframe.attr('src', src + sep + 'autoplay=1');
        }

        function unloadVideos($scope) {
            $scope.find('iframe[src]').removeAttr('src');
            $scope.find('.fb-video').each(function () {
                delete fbPlayers[this.id];
                delete fbPending[this.id];
                $(this).remove();
            });
            $scope.find('iframe[data-src]').css('display', '');
            $scope.find('.video-poster').show();
        }

        function playFromPoster($poster) {
            loadVideo($poster.siblings('iframe[data-src]').first(), true);
            $poster.hide();
        }

        $slider.on('click', '.video-poster', function () {
            playFromPoster($(this));
        });

        $slider.on('keydown', '.video-poster', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                playFromPoster($(this));
            }
        });

        //Stop videos from playing when sliding: unload every player and restore
        //the posters. Also on slick's responsive `breakpoint` (it rebuilds the
        //clones), so a live `src` is never copied into a clone.
        $slider.on('beforeChange breakpoint', function () {
            unloadVideos($(this));
        });

        $slider.slick({
            dots: true,
            speed: 500,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            appendDots: $('.appenddots'),
            responsive: [
                {
                    breakpoint: 1160,
                    settings: {
                        arrows: false
                    }
                }   
            ]
        });

        $('.prev-slide').on('click', function () {
            $slider.slick('slickPrev');
        });

        $('.next-slide').on('click', function () {
            $slider.slick('slickNext');
        });
    })();

    /**
     * Ratings and Reviews Carousel
     */
    (function() {

        let $ratingsSlider = $('.ratings-and-reviews-slider');

        $ratingsSlider.each(function() {
            const $slider = $(this);
            const $nav = $slider.siblings('.ratings-and-reviews-nav');
            const $awards = $('.ratings-and-reviews').find('.award-badge');

            //Hide the nav arrows when there's only a single slide to page through.
            $slider.on('init', function (event, slick) {
                $nav.toggle(slick.slideCount > 1);
                if(slick.slideCount > 1) {
                    $awards.addClass('spacing');
                }
            });

            $slider.slick({
                dots: false,
                arrows: false,
                infinite: true,
                speed: 800,
                slidesToShow: 1,
            }).on('setPosition', function (event, slick) {
                //Equalize slides to the tallest slide's natural height so the
                //track doesn't resize per-slide and cause a jump on transition.
                //Use 'auto' (not '') to override the CSS `height: 100%` on the
                //slide; otherwise every slide measures as the track's current
                //height and the max is meaningless.
                const $slides = slick.$slides;
                $slides.css('height', 'auto');
                let maxH = 0;
                $slides.each(function () {
                    const h = $(this).outerHeight();
                    if (h > maxH) maxH = h;
                });
                $slides.css('height', maxH + 'px');
                //Lock the track too so slick's own height management can't shrink
                //it during transitions.
                slick.$slideTrack.css('height', maxH + 'px');
            });

            $('.prev-slide').on('click', function () {
                $ratingsSlider.slick('slickPrev');
            });

            $('.next-slide').on('click', function () {
                $ratingsSlider.slick('slickNext');
            });
        });

    })();

    //Quote Board Carousel
    (function() {
        let $quoteBoardSlider = $('.quote-board-slider');

        $quoteBoardSlider.each(function() {
            const $slider = $(this);
            const $nav = $slider.closest('.quote-board').find('.quote-board-nav');
            const $prev = $nav.find('.prev-slide');
            const $next = $nav.find('.next-slide');

            function updateNavState(slick) {
                const scrollable = slick.slideCount > slick.options.slidesToShow;
                $nav.toggle(scrollable);
                if (!scrollable) return;
                const atStart = slick.currentSlide === 0;
                const atEnd = slick.currentSlide >= slick.slideCount - slick.options.slidesToShow;
                $prev.prop('disabled', atStart);
                $next.prop('disabled', atEnd);
            }

            $slider.on('init afterChange breakpoint', function (event, slick) {
                updateNavState(slick);
            });

            $slider.slick({
                dots: false,
                arrows: false,
                infinite: false,
                speed: 300,
                slidesToShow: 4,
                slidesToScroll: 3,
                responsive: [
                    {
                        breakpoint: 1280,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });

            $prev.on('click', function () {
                $slider.slick('slickPrev');
            });

            $next.on('click', function () {
                $slider.slick('slickNext');
            });
        });
        
    })();

}